import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class BecomeService {
  constructor(private httpClient: HttpClient) {}

  startSession(identificationType: string | number) {
    return this.httpClient.post(`${environment.serverUrl}/app/become/startSession`, {
      identificationType
    });
  }

  verifyValidate(userId: string) {
    return this.httpClient.post(`${environment.serverUrl}/app/become/verifyValidate`, {
      userId
    });
  }
}
